var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app-table__cell",class:[_vm.cell.prop, _vm.cell.propType,]},[_c('div',{staticClass:"app-table__cell-content"},[_c('a',{staticClass:"el-button app-icon-btn small phone-btn",class:{'main-phone': _vm.entity.mainPhoneFlag},attrs:{"href":`tel:${_vm.phone}`}},[_c('icon',{attrs:{"name":"phone"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }